import type { MessageSummary, PhotoAskPage } from "@/shared/contracts";

export type PhotoAskStatusText = "照片还在准备" | "照片结果还在确认" | "这次照片没有准备好" | "照片已准备好" | "这次请求已有结果，当前没有可查看的照片";
const canonical = (value: unknown): string => JSON.stringify(value, (_key, row: unknown) =>
  row && typeof row === "object" && !Array.isArray(row)
    ? Object.fromEntries(Object.entries(row).sort(([a], [b]) => a.localeCompare(b))) : row);

/** 一页不是全集。只认准确来源消息；重复矛盾记录不挑最新、不拼状态。 */
export function photoAskStatusFor(page: PhotoAskPage | null, message: MessageSummary, petId: string): PhotoAskStatusText | null {
  if (!page || message.sender !== "owner" || (message.channel ?? "private") !== "private") return null;
  const unique = new Map<string, typeof page.items[number]>();
  const conflicts = new Set<string>();
  for (const row of page.items) {
    const before = unique.get(row.request_id);
    if (before && canonical(before) !== canonical(row)) conflicts.add(row.request_id);
    else unique.set(row.request_id, row);
  }
  const matched = page.items.filter(row => row.source_message_id === message.message_id);
  if (matched.some(row => conflicts.has(row.request_id))) return null;
  const records = [...unique.values()].filter(row => row.source_message_id === message.message_id);
  if (records.length !== 1 || records[0]!.pet_id !== petId) return null;
  const row = records[0]!;
  switch (row.status) {
    case "processing": return "照片还在准备";
    case "checking": return "照片结果还在确认";
    case "failed": return "这次照片没有准备好";
    case "ready": return row.generation_state === "ready" && row.photo?.generation?.state === "ready"
      && row.photo.pet_id === petId && Boolean(row.photo_id) && row.photo.photo_id === row.photo_id
      ? "照片已准备好" : "这次请求已有结果，当前没有可查看的照片";
    default: return null;
  }
}

/** 只加说明，不渲染记录 URL、不改原消息附件，也没有重试命令。 */
export function PhotoAskStatusLine({ text }: { text: PhotoAskStatusText | null }) {
  return text ? <span className="ps-msg__photo-ask-status" role="status">{text}</span> : null;
}
